import { render, staticRenderFns } from "./CodesHistoryPanel.vue?vue&type=template&id=704d8b92&scoped=true"
import script from "./CodesHistoryPanel.vue?vue&type=script&lang=js"
export * from "./CodesHistoryPanel.vue?vue&type=script&lang=js"
import style0 from "./CodesHistoryPanel.vue?vue&type=style&index=0&id=704d8b92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704d8b92",
  null
  
)

export default component.exports